module.exports = __webpack_public_path__ + "static/media/dashboard.7217f10c.svg";